<ngb-alert [type]="'success'" *ngIf="statusMessage">
  {{ statusMessage }}
</ngb-alert>

<app-spinner *ngIf="isLoading"></app-spinner>

<div class="card" *ngIf="!isLoading">
  <div class="card-header">
    Usuarios/as registrados en la aplicación
    <small class="text-muted float-right">
      {{ usersLength }} usuarios/as registrados
    </small>
  </div>
  <div class="card-body table-card-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Apellido(s)</th>
            <th scope="col">E-mail</th>
            <th scope="col">Fecha registro</th>
            <th scope="col">Última conexión</th>
            <th scope="col">Rol</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let user of users"
            [routerLink]="['/usuarios/editar', user.user_id]"
          >
            <td>{{ user.firstname }}</td>
            <td>{{ user.surname }}</td>
            <td>{{ user.email }}</td>
            <td>
              {{
                user.date_privacy_accepted
                  .substr(0, 16)
                  .replace('T', '&nbsp;&nbsp;')
              }}
            </td>
            <td *ngIf="user.date_last_login">
              {{
                user.date_last_login.substr(0, 16).replace('T', '&nbsp;&nbsp;')
              }}
            </td>
            <td *ngIf="!user.date_last_login">- Nunca -</td>
            <td>{{ user.role_description }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                [routerLink]="['/usuarios/editar', user.user_id]"
              >
                Editar
              </button>
              <!--&nbsp;
        <button
          type="button"
          class="btn btn-sm btn-danger"
          (click)="
            onDelete(
              user.user_id,
              user.role_description,
              user.firstname,
              user.surname,
              user.email
            )
          "
        >
          Eliminar
        </button>-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ngb-pagination
  *ngIf="usersLength > pageSize && !isLoading"
  class="d-flex justify-content-center"
  [(page)]="currentPage"
  (pageChange)="onPageChange($event)"
  [pageSize]="pageSize"
  [collectionSize]="usersLength"
  [boundaryLinks]="false"
  [maxSize]="5"
  [rotate]="true"
></ngb-pagination>
